import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useEffect, useState } from 'react';

export const CustomHeader = (props) => {
  const onCheckboxChange = () => {
    props.api.deselectAll();
  };
  const [isRowsSelected, setIsRowsSelected] = useState(false);
  const handleChange = (params) => {
    const rowsSelected = params.api.getSelectedNodes();
    if (rowsSelected && rowsSelected.length) {
      setIsRowsSelected(rowsSelected.length > 0);
    }
  };

  useEffect(() => {
    props.api.addEventListener('selectionChanged', handleChange);
    return () => {
      props.api.removeEventListener('selectionChanged', handleChange);
    };
  }, [props]);

  return (
    <div
      className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ${isRowsSelected ? 'ag-indeterminate' : ''}`}
      style={{ opacity: isRowsSelected ? '' : '0.3' }}
    >
      <input
        onChange={onCheckboxChange}
        className="ag-input-field-input ag-checkbox-input"
        type="checkbox"
        disabled={!isRowsSelected}
      />
    </div>
  );
};
